import { findBand, BAND_COLORS } from "../bands";

// ESSPRI — EULAR Sjögren's Syndrome Patient Reported Index.
// Equally-weighted mean of three 0–10 patient VAS scores (dryness, fatigue, pain).
// A score >= 5 indicates a high symptom burden.
const esspriBands = [
    { label: "Acceptable symptom state", color: BAND_COLORS.low, lt: 5 },
    { label: "High symptom burden (≥5)", color: BAND_COLORS.high },
];

export const esspri = {
    id: "esspri",
    name: "ESSPRI",
    subtitle: "EULAR Sjögren's syndrome patient reported index",
    group: "Sjögren's syndrome",
    status: "ready",
    layout: "stacked",
    options: [],
    fields: [
        {
            key: "dryness",
            label: "How severe has your dryness been during the last 2 weeks?",
            hint: "0 = No dryness",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "fatigue",
            label: "How severe has your fatigue been during the last 2 weeks?",
            hint: "0 = No fatigue",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "pain",
            label: "How severe has your pain (joint or muscular pains in your arms or legs) been during the last 2 weeks?",
            hint: "0 = No pain",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
    ],
    compute: (v) => (v.dryness + v.fatigue + v.pain) / 3,
    interpret: (score) => findBand(score, esspriBands),
    bands: () => esspriBands,
    about:
        "EULAR Sjögren's syndrome patient reported index (ESSPRI) is a very simple index designed to measure patients' symptoms in primary Sjögren's syndrome. It is the equally-weighted mean of three 0–10 patient assessments over the last 2 weeks — dryness, fatigue, and limb (joint or muscular) pain. It has good construct validity and correlates well with the Profile of Fatigue and Discomfort (PROFAD) and Sicca Symptoms Inventory (SSI). A score of 5 or above indicates a high symptom burden.",
    references: [
        "Seror R, et al. EULAR Sjögren's Syndrome Patient Reported Index (ESSPRI): development and validation. Ann Rheum Dis. 2011.",
    ],
};
